/**
 * @since 1.0.0
 */
export var tailRec = function (f, a) {
    var v = f(a);
    while (v.isLeft()) {
        v = f(v.value);
    }
    return v.value;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fp-ts/es6/ChainRec.js
// module id = 932
// module chunks = 0